import React, { useState } from 'react';
import styled from 'styled-components';
import { useLang } from '../../context/LangContext';
import CenteredLayout from '../../layout/CenteredLayout';
import MainLayout from '../../layout/MainLayout';
import ProjectAppbar from '../../customComponents/ProjectAppbar';
import TabBar from '../../components/TabBar';
import WonAuctions from './WonAuctions';
import BidHistory from './BidHistory';

const AuctionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top:4px;
  /* margin-top: 16px; */
`;

// 다국어 텍스트
const auctionTexts = {
  ko: {
    title: '경매',
    wonAuctions: '나의 낙찰 내역',
    bidHistory: '나의 입찰 내역'
  },
  en: {
    title: 'Auction',
    wonAuctions: 'My Won Auctions',
    bidHistory: 'My Bid History'
  }
};

function Auction() {
  const { lang } = useLang();
  const texts = auctionTexts[lang];
  
  // 탭 상태 관리
  const [activeTab, setActiveTab] = useState(0);
  
  // 탭 목록
  const tabs = [texts.wonAuctions, texts.bidHistory];
  
  // 탭 변경 핸들러
  const handleTabChange = (tabIndex: number) => {
    setActiveTab(tabIndex);
  };
  
  // 현재 탭에 따른 컴포넌트 렌더링
  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <WonAuctions />;
      case 1:
        return <BidHistory />;
      default:
        return <WonAuctions />;
    }
  };

  return (
    <MainLayout currentPage="auction">
      <CenteredLayout>
        <ProjectAppbar 
          currentPage="auction"
          title={texts.title}
        />
        <AuctionContainer>
          <TabBar 
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          <ContentContainer>
            {renderTabContent()}
          </ContentContainer>
        </AuctionContainer>
      </CenteredLayout>
    </MainLayout>
  );
}

export default Auction;
